import { ExtendedTractor } from '@hooks/useDriverTractors.types';
import { ErrorOutlineTwoTone } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { isTractorSelectable } from './types';

import styles from './DataGrid.Tractor.module.css';
import global from '@/Global.module.css';

interface MobileTractorItemProps {
  tractor: ExtendedTractor;
  requiresHazmatCert?: boolean;
}

/**
 * Mobile-friendly list of Drivers used for assigning a driver/tractor. Displays Driver Name and Code along with Elog/Hazmat compliance.
 */
export default function MobileTractorItem({ tractor, requiresHazmatCert }: MobileTractorItemProps) {
  const defaultDriver = tractor.drivers?.find((driver) => driver.id === tractor.drvId);
  const selectionStatus = isTractorSelectable(tractor, requiresHazmatCert);

  return (
    <div className={styles['mobile-li']}>
      <Tooltip
        slotProps={{
          popper: {
            className: styles.tooltip
          }
        }}
        title={
          selectionStatus.disabledReason.length > 0 && (
            <ul className={styles['disabled-reasons-ul']}>
              {selectionStatus.disabledReason.map((reason, index) => (
                <li key={`disabled-reason-${String(index)}`}>{reason}</li>
              ))}
            </ul>
          )
        }>
        <span className={`${styles.topleft} ${global.bold}`}>
          {!selectionStatus.isSelectable && <ErrorOutlineTwoTone className={styles['mobile-disabled']} />}

          {tractor.id}
        </span>
      </Tooltip>

      <span className={styles.topright}>{tractor.pltNo}</span>

      <span className={styles.bottomleft}>Current Driver:</span>
      <div className={styles.bottomcenter}>
        <span>
          {tractor.drivers?.length === 1 && defaultDriver && <>{defaultDriver.name}</>}
          {((tractor.drivers?.length === 1 && !defaultDriver) || (tractor.drivers && tractor.drivers.length > 1)) && <>*</>}
        </span>
      </div>
    </div>
  );
}
